import { useCallback } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

import {
  buildScheduleBlockHourLineSx,
  buildScheduleBlockSx,
  WEEKLY_SCHEDULE_BLOCK_LABEL_SX,
  WEEKLY_SCHEDULE_BLOCK_TOP_ROW_SX,
  WEEKLY_SCHEDULE_DELETE_BUTTON_SX,
  WEEKLY_SCHEDULE_TOOLTIP_TIME_SX,
  WEEKLY_SCHEDULE_TOOLTIP_TITLE_SX,
} from '../styles';
import { getScheduleBlockHourOffsets } from '../utils';

import type { ScheduleBlockProps } from '../types';

export default function ScheduleBlock({
  item,
  onDelete,
  showBottomDivider,
}: ScheduleBlockProps) {
  const handleDelete = useCallback(() => {
    onDelete?.(item.id);
  }, [item.id, onDelete]);

  return (
    <Tooltip
      arrow
      title={
        <>
          <Typography component="span" sx={WEEKLY_SCHEDULE_TOOLTIP_TITLE_SX}>
            {item.activity_label}
          </Typography>
          <Typography component="span" sx={WEEKLY_SCHEDULE_TOOLTIP_TIME_SX}>
            {item.tooltipTimeRangeLabel}
          </Typography>
        </>
      }
    >
      <Box sx={buildScheduleBlockSx(item, showBottomDivider)}>
        {item.isMultiHour
          ? getScheduleBlockHourOffsets(item.durationHours).map((hourOffset) => (
              <Box aria-hidden key={hourOffset} sx={buildScheduleBlockHourLineSx(hourOffset)} />
            ))
          : null}
        <Box sx={WEEKLY_SCHEDULE_BLOCK_TOP_ROW_SX}>
          <Typography component="span" sx={WEEKLY_SCHEDULE_BLOCK_LABEL_SX}>
            {item.isMultiHour ? item.startTimeLabel : item.rangeTimeLabel}
          </Typography>
          {onDelete != null ? (
            <IconButton
              aria-label={`Delete ${item.activity_label} schedule at ${item.startTimeLabel}`}
              onClick={handleDelete}
              size="small"
              sx={WEEKLY_SCHEDULE_DELETE_BUTTON_SX}
            >
              <DeleteOutlineIcon />
            </IconButton>
          ) : null}
        </Box>
        {item.isMultiHour ? (
          <Typography component="span" sx={WEEKLY_SCHEDULE_BLOCK_LABEL_SX}>
            {item.endTimeLabel}
          </Typography>
        ) : null}
      </Box>
    </Tooltip>
  );
}
